import { useMutation } from '@sequencehq/api'
import { dashboard20240730Client } from '@sequencehq/api/dashboard/v20240730'
import { useNotifications } from '@sequencehq/core-components'
import { FC } from 'react'
import { useNavigate } from 'react-router-dom'

import { NotificationPolicySettings } from 'SettingsV2/components/notifications/NotificationsPolicySettings'

export const NotificationsNewPolicySettingsPage: FC = () => {
  const { displayNotification } = useNotifications()
  const navigate = useNavigate()

  const mutator = useMutation(dashboard20240730Client.postNotificationPolicy, {
    onSuccess: () => {
      displayNotification('Notification policy created', {
        type: 'success'
      })
      navigate('/settings/notifications')
    },
    onError: () => {
      displayNotification(`Failed to create notification policy.`, {
        type: 'error'
      })
    }
  })

  return (
    <NotificationPolicySettings
      channel="EMAIL"
      header="Create new policy"
      isPending={mutator.isPending}
      onSubmit={formData => {
        mutator.mutate({
          name: formData.name,
          recipients: formData.recipients,
          notificationTypes: formData.notificationTypes,
          channel: 'EMAIL'
        })
      }}
    />
  )
}
